import type {
  StripeCreateCustomerBillingResponse,
  StripeCreateCustomerResponse,
  StripeCreateCustomerSessionResponse,
} from "@/common/types/stripe";
import axiosClient from "@/lib/axios/axiosClient";

export async function createCustomerSession({
  customerId,
}: {
  customerId: string;
}): Promise<StripeCreateCustomerSessionResponse> {
  const response = await axiosClient.post<StripeCreateCustomerSessionResponse>(
    "/stripe-create-customer-session",
    {
      customer: customerId,
    },
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );
  return response.data;
}

export async function createCustomerBillingSession({
  customerId,
}: {
  customerId: string;
}): Promise<StripeCreateCustomerBillingResponse> {
  const response = await axiosClient.post<StripeCreateCustomerBillingResponse>(
    "/stripe-customer-billing-session",
    {
      customer: customerId,
    },
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );
  return response.data;
}

export async function createCustomer({
  email,
  name,
}: {
  email: string;
  name: string;
}): Promise<StripeCreateCustomerResponse> {
  const response = await axiosClient.post<StripeCreateCustomerResponse>(
    "/stripe-create-customer",
    {
      name: name,
      email: email,
    },
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );
  return response.data;
}
